import {
  ArticleParagraph1,
  UIHeading2,
  Button,
  Image,
  Link,
  Modal,
  ModalClose,
  ModalDescription,
  ModalTitle,
} from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { IAlertModalWarning } from '../../types/alert';

type TNoForbiddenTextPopupProps = {
  isMobile: boolean;
  handleClickLinkButton?: () => void;
  modalWarning: IAlertModalWarning;
  handleClose(isClickedSubmitButton?: boolean): void;
};

export const NoForbiddenTextPopup: React.FC<TNoForbiddenTextPopupProps> = ({
  handleClickLinkButton,
  modalWarning,
  isMobile,
  handleClose,
}) => {
  return (
    <Modal
      onEscapeKeyDown={() => handleClose()}
      onPointerDownOutside={() => handleClose()}
      onFocusOutside={() => handleClose()}
      onInteractOutside={() => handleClose()}
      size="S"
      data-name="modalWarningPopup"
      open
      onOpenChange={() => {}}
      closeButtonProps={{
        theme: 'fill_light',
        title: 'Закрыть',
        icon: <IconActionClose16 color="current_color" />,
        onClick: () => handleClose(),
      }}
      header={
        <ModalTitle>
          <div className={classNames(styles['header'], isMobile && styles['header_mobile'])}>
            {modalWarning.iconUrl && (
              <div className={styles['image']}>
                <Image src={modalWarning.iconUrl} />
              </div>
            )}
            <UIHeading2>{modalWarning.title}</UIHeading2>
          </div>
        </ModalTitle>
      }
      body={
        <ModalDescription>
          <div className={classNames(styles['description'], isMobile && styles['description_mobile'])}>
            <ArticleParagraph1>{modalWarning.description}</ArticleParagraph1>
            {modalWarning.buttonLink && modalWarning.buttonLink.url && (
              <span className={styles['button']}>
                <Link
                  data-name="modalWarningLinkButton"
                  href={modalWarning.buttonLink.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleClickLinkButton}
                >
                  {modalWarning.buttonLink.text}
                </Link>
              </span>
            )}
          </div>
        </ModalDescription>
      }
      footer={
        <ModalClose asChild>
          <div className={classNames(styles['footer'], isMobile && styles['footer_mobile'])}>
            <Button
              fullWidth={isMobile}
              onClick={() => handleClose(true)}
              data-name="modalWarningSubmitButton"
              size={isMobile ? 'L' : 'M'}
            >
              {modalWarning.closeButtonText}
            </Button>
          </div>
        </ModalClose>
      }
    />
  );
};
